// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + {"src_containers_Home_Home_jsx":"dff9962030bb6718f2e0","src_containers_Certificates_index_jsx":"4f8e95c771b4fc92edf4"}[chunkId] + ".js";
};